import { IssueEntity } from 'types/IssueEntity'

type TranslateFn = (key: string, options?: Record<string, unknown>) => string

/**
 * Om aktien bytt namn i instrument_history efter publiceringsdatum skiljer sig
 * nameAtPublication från currentName. Då ska namnet vid emissionen visas.
 */
export function getShareNameAtPublicationHint(issue: IssueEntity, t: TranslateFn): string | null {
    const meta = issue.shareNameMetadata
    if (!meta?.nameAtPublication || meta.currentName == null) return null
    if (meta.currentName === meta.nameAtPublication) return null

    const atPub = meta.nameAtPublication

    if (issue.type === 'IPO') {
        return t('pages.issues.shareNameHint.atIpo', { name: atPub })
    }

    return t('pages.issues.shareNameHint.atIssue', { name: atPub })
}
